import { c as _c } from "react/compiler-runtime";
import { Button } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
type CaptureButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  variant: 'default' | 'round' | 'stop';
};
const CaptureButton = t0 => {
  const $ = _c(11);
  const {
    onClick,
    disabled: t1,
    variant
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== disabled || $[1] !== onClick || $[2] !== variant) {
    t2 = variant === "default" && <Button fullWidth={true} aria-disabled={disabled} data-disabled={disabled} onClick={onClick} disabled={disabled} size="large" data-dd-action-name="doc:take-photo">Take photo</Button>;
    $[0] = disabled;
    $[1] = onClick;
    $[2] = variant;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== disabled || $[5] !== onClick || $[6] !== variant) {
    t3 = (variant === "round" || variant === "stop") && <div role="button" tabIndex={0} aria-disabled={disabled} data-disabled={disabled} onClick={onClick} onKeyDown={e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick();
      }
    }} className={cx("flex justify-center items-center bg-transparent rounded-full absolute bottom-4 cursor-pointer w-[72px] h-[72px]", "border-[6px] border-solid border-white", disabled && "border-senary pointer-events-none")} data-dd-action-name="doc:take-photo">{variant === "round" ? <button type="button" aria-disabled={disabled} data-disabled={disabled} className={cx("bg-white border-none rounded-full shadow-md w-14 h-14", disabled && "bg-senary", "active:bg-white/80")} data-dd-action-name="doc:take-photo" /> : <button type="button" className="w-6 h-6 bg-white border-none rounded-sm shadow-md" />}</div>;
    $[4] = disabled;
    $[5] = onClick;
    $[6] = variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default CaptureButton;